<template>
  <header class="is-flex is-justify-content-space-between is-align-content-center mb-4">
    <div class="is-flex is-align-items-center">
      <figure class="image is-24x24 mr-2">
        <img :src="props.service.logo_url" />
      </figure>
      <h4 class="has-text-dark has-text-weight-bold is-size-4" style="height: min-content">
        {{ props.service.integration_name }} integration is not active yet
      </h4>
    </div>
    <button class="close-btn" @click="close">✕</button>
  </header>
  <section class="is-flex is-flex-direction-column mb-4">
    <p class="has-text-dark mb-3">If you want an overview of all integrations, Go to <a>Integrations</a>.</p>
    <div class="is-flex is-justify-content-space-around">
      <Image :src="imgSrc" class="py-5" width="240" style="filter: opacity(0.75)"/>
    </div>
  </section>
  <footer class="is-flex is-justify-content-flex-end has-background-white">
    <div class="buttons ">
      <button class="button" @click="close">Cancel</button>
      <button class="button is-success has-text-weight-bold"
              style="background-image: linear-gradient(45deg, #E100FF 0%, #7F00FF 100%); color: white; border: none;--bulma-loading-color:white"
              @click="integrate()">
        Activate
      </button>
    </div>
  </footer>
</template>

<script setup>
import imgSrc from '@/assets/images/connection.svg';

const props = defineProps(['service'])
const emit = defineEmits(['closed'])

const PARENT_APP_URL = import.meta.env.VITE_PARENT_APP_URL;

function close() {
  emit('closed');
}

function integrate() {
  parent.postMessage({
    "MessageId": "Integrate_Action",
    "SendTime": Date.now(),
    "Values": {
      "integration_type": props.service.integration_type
    },
    "Origin": location.origin,
  }, PARENT_APP_URL);
}

</script>
